<template>
  <div class="edit_page">
    <div class="edit_wrapper"></div>
    <div class="edit">
      <div class="edit_top">
        <div class="edit_top_buttons">
          <router-link to="/assigns">
            <input type="button" :value="cancelButton" class="cancel_button" />
          </router-link>
          <input
            type="button"
            :value="addButton"
            class="finish_button"
            @click="showModal = true"
          />
        </div>
      </div>
      <div class="detail">
        <div class="detail_contents">
          <div class="assign_assign detail_content">
            <div class="assign_assign_label detail_label">
              {{ nameLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <input
              class="detail_input_field"
              type="text"
              @input="inputAddUpdate('name')"
            />
          </div>
          <div class="assign_type detail_content">
            <div class="assign_type detail_label">
              {{ typeLabel }}
              <div class="require_items_label">
                {{ requiredItemLabel }}
              </div>
            </div>
            <select class="drop_down_list" v-model="selectedTypeId" :style="selectedStyle" @change="inputAddUpdate('type')">
              <option disabled selected value="" style="background-color: lightgray; color: white;">{{ selectedColorName.name }}</option>
              <option v-for="type in typeList" :value="type.id" :key="type.id" :style="{ backgroundColor: type.background, color: type.text}" >
                {{ type.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal_window" v-if="showModal">
        <addModalWindow @close="stayClose" @add="addAssign"> </addModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showCompleteModal">
        <completeModalWindow :question="completeWord" @close="close">
        </completeModalWindow>
      </div>
      <div class="complete_modal_window" v-if="showFailureModal">
        <completeModalWindow :question="failureWord" @close="stayClose">
        </completeModalWindow>
      </div>
      <div class="loading_modal_window" v-if="showloadingModal">
        <loadingModalWindow @close="close"> </loadingModalWindow>
      </div>
    </div>
  </div>
</template>

<script>
import addModalWindow from '../modalWindow/addModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      cancelButton: 'キャンセル',
      addButton: '追加',
      nameLabel: '役割',
      typeLabel: '色',
      completeWord: '',
      failureWord: '',
      showModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showFailureModal: false,
      selectedTypeId: ''
    }
  },
  async created() {
    this.$store.dispatch('assigns/clearAssign')
  },
  components: {
    addModalWindow,
    completeModalWindow,
    loadingModalWindow
  },
  computed: {
    assigns() {
      return this.$store.state.assigns.assigns
    },
    typeList() {
      return this.$store.state.assigns.typeList
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    requiredItemLabel() {
      return this.$store.state.error.requiredItemLabel
    },
    selectedType() {
      return this.typeList.find(type => type.id === this.selectedTypeId);
    },
    selectedStyle() {
      return this.selectedType
        ? {
            backgroundColor: this.selectedType.background,
            color: this.selectedType.text
          }
        : {
            backgroundColor: this.typeList[0].background,
            color: this.typeList[0].text
          }
    },
    selectedColorName() {
      return this.selectedType
        ? {
            name: this.selectedType.name
          }
        : {
            name: this.typeList[0].name
          }
    }
  },
  methods: {
    inputAddUpdate(e) {
      this.$store.dispatch('assigns/inputAddUpdate', {
        name: e,
        value: event.target.value
      })
    },
    close(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.$router.push('/assigns')
    },
    stayClose(e) {
      this.showModal = false
      this.showCompleteModal = false
      this.showFailureModal = false
    },
    async addAssign(e) {
      this.showloadingModal = true
      try {
        await this.$store.dispatch('assigns/addAssign')
        this.$emit('list-reload')
        this.showModal = false
        this.completeWord = '追加しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_660001
        let eventType = 3
        let reason = ''
        if (
          error.response &&
          error.response.data &&
          error.response.data.header &&
          error.response.data.header.message
        ) { 
          let errorMessage = error.response.data.header.message
          if (errorMessage === 'MSGCRC0207') {
            this.failureWord =
              this.errorMsg.MSGCRC0207.name +
              this.errorMsg.MSGCRC0207.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0208') {
            this.failureWord =
              this.errorMsg.MSGCRC0208.name +
              this.errorMsg.MSGCRC0208.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else if (errorMessage === 'MSGCRC0268') {
            this.failureWord =
              this.errorMsg.MSGCRC0268.name +
              this.errorMsg.MSGCRC0268.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          } else {
            this.failureWord =
              this.errorMsg.MSGCRC0226.name +
              this.errorMsg.MSGCRC0226.value +
              'エラーコード：{' +
              eventNumber +
              '}'
          }
          reason = errorMessage + ' '
          reason += error.response.status
         } else { 
            reason = 'MSGCRC0005'
            eventType = 9
            this.failureWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showModal = false
        this.showFailureModal = true
      }
      this.showloadingModal = false
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/assigns/assignAdd.vue